import { PcApiResponse } from '@/api/pc-api/types';
import { BizType } from '@/constants/bizType';
import { CiPermission, CsCenterType, SvcReviewStatusType } from '@/constants/svc';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

type DefaultSvc = {
  companyName: string;
  ciEvidence: string;
  ciPermission: CiPermission;
  contractCount: number;
  devIps: string[];
  evalStatus: string;
  id: number;
  logoUrl: string;
  realIps: string[];
  svcName: string;
  reviewStatus: SvcReviewStatusType;
  reviewRejectReason: string;
  alimTalkImageUrl?: string;
};

/** 채널: 카카오 지갑채널 && cs타입: 전화번호 */
type Svc1 = {
  useWalletChannel: true;
  csCenterType: CsCenterType.PHONE_NUMBER;
  csCenterPhoneNumber: string;
} & DefaultSvc;

/** 채널: 카카오 지갑채널 && cs타입: url */
export type Svc2 = {
  useWalletChannel: true;
  csCenterType: CsCenterType.PARTNER_CHANNEL;
  csCenterChannelUrl?: string;
  csCenterChannelUuid?: string;
} & DefaultSvc;

/** 채널: 이용기관 채널 && cs타입: 전화번호 */
export type Svc3 = {
  useWalletChannel: false;
  channelUrl?: string;
  channelUuid?: string;
  csCenterType: CsCenterType.PHONE_NUMBER;
  csCenterPhoneNumber: string;
} & DefaultSvc;

/** 채널: 이용기관 채널 && cs타입: url */
type Svc4 = {
  useWalletChannel: false;
  channelUrl?: string;
  channelUuid?: string;
  csCenterType: CsCenterType.PARTNER_CHANNEL;
  csCenterChannelUrl?: string;
  csCenterChannelUuid?: string;
} & DefaultSvc;

export type Svc = Svc1 | Svc2 | Svc3 | Svc4;

export type PartnerRes = {
  bizType: BizType;
  id: string;
  businessNumber: string;
  svc: Svc;
};

export const getPartner = (partnerId: string) => {
  return api<PcApiResponse<PartnerRes>>('get', `/pc-api/v1/${PREFIX_PATH}/partner/${partnerId}/init-info`);
};
